import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import { visuallyHidden } from "@mui/utils";
import Popover from "@mui/material/Popover";
import { List, ListItem, ListItemButton, ListItemText } from "@mui/material";
import { BiChevronDown } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import Popup from "reactjs-popup";

function createData(
  id,
  date,
  lastName,
  firstName,
  discipline,
  address,
  phoneNumber,
  referralSource,
  status,
  comment
) {
  return {
    id,
    date,
    lastName,
    firstName,
    discipline,
    address,
    phoneNumber,
    referralSource,
    status,
    comment,
  };
}

const rows = [
  createData(
    1,
    "19-02-2023",
    "Cameron",
    "Williamson",
    "PT",
    "2972 Westheimer Rd. Santa Ana, Illinois 85486",
    "(209) 555-0104",
    "Facebook",
    "Completed",
    "Comment XYZ"
  ),
  createData(
    2,
    "19-02-2023",
    "Cameron",
    "Williamson",
    "PT",
    "2972 Westheimer Rd. Santa Ana, Illinois 85486",
    "(209) 555-0104",
    "Facebook",
    "Completed",
    "Comment XYZ"
  ),

  createData(
    3,
    "19-02-2023",
    "Cameron",
    "Williamson",
    "PT",
    "2972 Westheimer Rd. Santa Ana, Illinois 85486",
    "(209) 555-0104",
    "Facebook",
    "Completed",
    "Comment XYZ"
  ),
  createData(
    4,
    "19-02-2023",
    "Cameron",
    "Williamson",
    "PT",
    "2972 Westheimer Rd. Santa Ana, Illinois 85486",
    "(209) 555-0104",
    "Facebook",
    "Completed",
    "Comment XYZ"
  ),
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "id",
    numeric: false,
    disablePadding: true,
    label: "#",
  },
  {
    id: "date",
    numeric: true,
    disablePadding: false,
    label: "Date Applied",
  },
  {
    id: "lastName",
    numeric: true,
    disablePadding: false,
    label: "Last Name",
  },
  {
    id: "firstName",
    numeric: true,
    disablePadding: false,
    label: "First Name",
  },
  {
    id: "discipline",
    numeric: true,
    disablePadding: false,
    label: "Discipline",
  },
  {
    id: "address",
    numeric: true,
    disablePadding: false,
    label: "Address",
  },
  {
    id: "phoneNumber",
    numeric: true,
    disablePadding: false,
    label: "Phone Number",
  },
  {
    id: "referralSource",
    numeric: true,
    disablePadding: false,
    label: "Referral source",
  },
  {
    id: "status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "comment",
    numeric: true,
    disablePadding: false,
    label: "Comment",
  },
];

function StatusTableCell(props) {
  const [anchorStatusEl, setStatusAnchorEl] = React.useState(null);

  const handleStatusClick = (event) => {
    setStatusAnchorEl(event.currentTarget);
  };

  const handleStatusClose = () => {
    setStatusAnchorEl(null);
  };

  const open = Boolean(anchorStatusEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div className="cursor-pointer">
      <div
        aria-describedby={id}
        variant="contained"
        onClick={handleStatusClick}
        className="flex gap-2 items-center"
      >
        <div>{props.status} </div>{" "}
        <div>
          <BiChevronDown />
        </div>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorStatusEl}
        onClose={handleStatusClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <List className="w-[150px]">
          <ListItem disablePadding>
            <ListItemButton component="a" href="#simple-list">
              <ListItemText primary="Completed" className="!text-[#32D583]" />
            </ListItemButton>
          </ListItem>

          <ListItem disablePadding>
            <ListItemButton component="a" href="#simple-list">
              <ListItemText primary="Pending" className="!text-[#F4B40E]" />
            </ListItemButton>
          </ListItem>
        </List>
      </Popover>
    </div>
  );
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="left"
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{
              color: "#98A2B3",
              fontWeight: "bold!important",
              background: "#F7FAFC",
            }}
            className={
              headCell.id === "id" ? "offerTableIdHead" : "offerTableHead"
            }
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              sx={{
                "& .MuiTableSortLabel-icon": {
                  opacity: 0,
                  pointerEvents: "none",
                },
              }}
            >
              <p style={{ minWidth: "30px" }}>{headCell.label}</p>

              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default function OfferTableRow() {
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const navigate = useNavigate();

  const handleRequestSort = (_event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (id) => {
    // Navigate to a different page
    navigate(`/dashboard/offers/${id}`);
  };

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(rows, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage]
  );
  const [openPopup, setOpenPopup] = React.useState(
    Array(visibleRows.length).fill(false)
  );

  const handleMouseEnter = (index) => {
    const newOpenPopup = [...openPopup];
    newOpenPopup[index] = true;
    setOpenPopup(newOpenPopup);
  };

  const handleMouseLeave = (index) => {
    const newOpenPopup = [...openPopup];
    newOpenPopup[index] = false;
    setOpenPopup(newOpenPopup);
  };
  return (
    <Box sx={{ width: "100%" }} className="offers">
      <Paper sx={{ width: "100%", mb: 2 }}>
        <TableContainer className="tableContainer">
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size="medium"
            className="tableContainer"
          >
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {visibleRows.map((row, _index) => {
                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={row.id}
                    className="customTableRow"
                  >
                    <TableCell
                      align="left"
                      sx={{ cursor: "pointer", textDecoration: "underline" }}
                      onClick={(event) => handleClick(row.id)}
                      className="offerTableIdBody"
                    >
                      {row.id}
                    </TableCell>
                    <TableCell
                      align="left"
                      onClick={(event) => handleClick(row.id)}
                      className="offerTableBody"
                    >
                      {row.date}
                    </TableCell>
                    <TableCell
                      align="left"
                      onClick={(event) => handleClick(row.id)}
                      className="offerTableBody"
                    >
                      {row.lastName}
                    </TableCell>
                    <TableCell
                      align="left"
                      onClick={(event) => handleClick(row.id)}
                      className="offerTableBody"
                    >
                      {row.firstName}
                    </TableCell>
                    <TableCell
                      align="left"
                      onClick={(event) => handleClick(row.id)}
                      className="offerTableBody"
                    >
                      {row.discipline}
                    </TableCell>
                    <TableCell
                      align="left"
                      onClick={(event) => handleClick(row.id)}
                      className="offerTableBody"
                    >
                      <Popup
                        key={_index}
                        trigger={
                          <p
                            onMouseEnter={() => handleMouseEnter(_index)}
                            onMouseLeave={() => handleMouseLeave(_index)}
                          >
                            {row.address.slice(0, 13)}
                          </p>
                        } // Element that triggers the popup
                        position="top left"
                        open={openPopup[_index]}
                        closeOnDocumentClick
                        onClose={() => handleMouseLeave(_index)} // Close the popup when explicitly closed
                        mouseEnterDelay={200}
                        mouseLeaveDelay={20}
                      >
                        {/* Content inside the popup */}
                        <div className="text-black bg-white text-[12px] p-4 rounded-lg mt-[9px] shadow-xl">
                          {row.address}
                        </div>
                      </Popup>
                    </TableCell>
                    <TableCell
                      align="left"
                      onClick={(event) => handleClick(row.id)}
                      className="offerTableBody"
                    >
                      {row.phoneNumber}
                    </TableCell>
                    <TableCell
                      align="left"
                      onClick={(event) => handleClick(row.id)}
                      className="offerTableBody"
                    >
                      {row.referralSource}
                    </TableCell>
                    <TableCell
                      align="left"
                      className="!text-[#32D583] !font-bold relative z-[50] offerTableBody"
                    >
                      <StatusTableCell status={row.status} />
                    </TableCell>
                    <TableCell
                      align="left"
                      onClick={(event) => handleClick(row.id)}
                      className="offerTableBody"
                    >
                      {row.comment}
                    </TableCell>
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  );
}
